import { useEffect, useState } from 'react';
import { clinicSettingsService } from '../services/clinicSettings';

import api from '../services/api';

interface DashboardStats {
  totalPatients: number | string;
  todaysVisits: number | string;
  pendingLabResults: number | string;
  prescriptionsToday: number | string;
  paymentMethods?: {
    umum: number;
    bpjs: number;
    asuransi: number;
    perusahaan: number;
    paketPromosi: number;
    rujukan: number;
  };
  services?: {
    umum: number;
    apotikMandiri: number;
    labDokter: number;
    labMandiri: number;
    labPerusahaan: number;
    labRujukan: number;
    radDokter: number;
    radMandiri: number;
    radPerusahaan: number;
    radRujukan: number;
    gigi: number;
    kebidanan: number;
  };
  supportingTests?: {
    ekg: { doctor: number, patient: number, company: number };
    treadmill: { doctor: number, patient: number, company: number };
    audiometri: { doctor: number, patient: number, company: number };
    spirometri: { doctor: number, patient: number, company: number };
    refraksi: { doctor: number, patient: number, company: number };
  };
  radiologyBreakdown?: {
    xray: { doctor: number, patient: number, company: number };
    usg: { doctor: number, patient: number, company: number };
  };
  revenueTrends?: Array<{
    date: string;
    total_revenue: number;
    cash_revenue: number;
    insurance_revenue: number;
    bpjs_revenue: number;
    company_revenue: number;
    total_patients: number;
    new_patients: number;
    returning_patients: number;
  }>;
  recentActivities?: Array<{
    id: number;
    type: string;
    description: string;
    date: string;
  }>;
}

export const useDashboardStats = (
  filter: string = 'today',
  startDate?: string,
  endDate?: string,
  applyTrigger: number = 0
) => {
  const [clinicSettings, setClinicSettings] = useState<any>(null);
  const [stats, setStats] = useState<DashboardStats>({
    totalPatients: 'Loading...',
    todaysVisits: 'Loading...',
    pendingLabResults: 'Loading...',
    prescriptionsToday: 'Loading...',
  });
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchDashboardData = async () => {
      setIsLoading(true);
      try {
        const settings = await clinicSettingsService.getSettings();
        setClinicSettings(settings);
        
        // Fetch real stats from backend API
        const statsResponse = await api.get('/dashboard/stats', {
          params: { filter, startDate, endDate }
        });
        setStats(statsResponse.data.data);
        
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDashboardData();
  }, [filter, applyTrigger]); // Only refetch when filter or applyTrigger changes

  return { clinicSettings, stats, isLoading };
};
